/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recognition_Level_Two_NoteInputs */

const en_recognition_level_two_note = /** @type {(inputs: Recognition_Level_Two_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Professional communication & repeat clientele`)
};

const ar_recognition_level_two_note = /** @type {(inputs: Recognition_Level_Two_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تواصل احترافي وعملاء دائمون`)
};

const bn_recognition_level_two_note = /** @type {(inputs: Recognition_Level_Two_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পেশাদার যোগাযোগ ও পুনরাবৃত্ত ক্লায়েন্টেল`)
};

const de_recognition_level_two_note = /** @type {(inputs: Recognition_Level_Two_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Professionelle Kommunikation und Stammkunden`)
};

const es_recognition_level_two_note = /** @type {(inputs: Recognition_Level_Two_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comunicación profesional y clientela habitual`)
};

const fr_recognition_level_two_note = /** @type {(inputs: Recognition_Level_Two_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Communication professionnelle et clientèle fidèle`)
};

const pt_recognition_level_two_note = /** @type {(inputs: Recognition_Level_Two_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comunicação profissional e clientela recorrente`)
};

const zh_recognition_level_two_note = /** @type {(inputs: Recognition_Level_Two_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`专业沟通和回头客`)
};

const tr_recognition_level_two_note = /** @type {(inputs: Recognition_Level_Two_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profesyonel iletişim ve sadık müşteriler`)
};

const ru_recognition_level_two_note = /** @type {(inputs: Recognition_Level_Two_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Профессиональное общение и постоянная клиентура`)
};

const pl_recognition_level_two_note = /** @type {(inputs: Recognition_Level_Two_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profesjonalna komunikacja i stała klientela`)
};

/**
* | output |
* | --- |
* | "Professional communication & repeat clientele" |
*
* @param {Recognition_Level_Two_NoteInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const recognition_level_two_note = /** @type {((inputs?: Recognition_Level_Two_NoteInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recognition_Level_Two_NoteInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_recognition_level_two_note(inputs)
	if (locale === "bn") return bn_recognition_level_two_note(inputs)
	if (locale === "de") return de_recognition_level_two_note(inputs)
	if (locale === "es") return es_recognition_level_two_note(inputs)
	if (locale === "fr") return fr_recognition_level_two_note(inputs)
	if (locale === "pt") return pt_recognition_level_two_note(inputs)
	if (locale === "zh") return zh_recognition_level_two_note(inputs)
	if (locale === "tr") return tr_recognition_level_two_note(inputs)
	if (locale === "ru") return ru_recognition_level_two_note(inputs)
	if (locale === "pl") return pl_recognition_level_two_note(inputs)
	return en_recognition_level_two_note(inputs)
});